import { h } from '@/lib/dom';

interface WindowSwitcherProps<K extends string> {
  current: K;
  windows: readonly K[];
  labelFor: (k: K) => string;
  onChange: (k: K) => void;
  /** Optional label prefix shown before the buttons, e.g. "Период:". */
  prefix?: string;
}

export function WindowSwitcher<K extends string>({
  current,
  windows,
  labelFor,
  onChange,
  prefix,
}: WindowSwitcherProps<K>): HTMLElement {
  const tablist = h('div', {
    class: 'flex gap-2 mb-4',
    role: 'tablist',
    aria: { label: 'Окно для средних значений' },
  },
    windows.map((w) =>
      h('button', {
        class: `btn btn-sm ${current === w ? 'btn-primary' : 'btn-secondary'}`,
        type: 'button',
        role: 'tab',
        aria: { selected: current === w ? 'true' : 'false' },
        on: { click: () => onChange(w) },
      }, labelFor(w))));

  if (!prefix) return tablist;

  return h('div', { class: 'nutrition-switcher-wrap' }, [
    h('span', { class: 'nutrition-switcher-label' }, prefix),
    tablist,
  ]);
}
